import type { ReactElement, ReactNode } from 'react';
import { cn } from './cn';

export interface KbdProps {
  /** Rendered as one chip per key, joined with a muted separator. */
  keys?: readonly string[];
  children?: ReactNode;
  className?: string;
}

const CHIP =
  'inline-flex min-w-5 items-center justify-center rounded border border-border ' +
  'bg-surface-sunken px-1.5 py-0.5 font-mono text-[11px] leading-4 text-ink-muted';

/** A keyboard key chip, e.g. in a shortcut list or a hint under a control. */
export function Kbd({ keys, children, className }: KbdProps): ReactElement {
  if (keys && keys.length > 0) {
    return (
      <span className={cn('inline-flex items-center gap-1', className)}>
        {keys.map((key, index) => (
          <span key={`${key}-${index}`} className="inline-flex items-center gap-1">
            {index > 0 && (
              <span aria-hidden="true" className="text-ink-faint">
                +
              </span>
            )}
            <kbd className={CHIP}>{key}</kbd>
          </span>
        ))}
      </span>
    );
  }

  return <kbd className={cn(CHIP, className)}>{children}</kbd>;
}
